<template>
    <a href="" class="block h-full" @click.prevent="$downloadFile(src, fileName)">
        <div class="thumbnail base-responsive-rounding aspect-h-3 aspect-w-5 mb-2 z-1">
            <img :src="src" :alt="imgAlt || fileName" />
        </div>

        <div class="flex justify-between">
            <div aria-hidden="true" class="auxiliary-text">{{ size }}</div>

            <Button
                tabindex="-1"
                :label="$t('media_library.download_photo')"
                class="p-button-secondary p-button-text -translate-x-2"
                icon="pi pi-download"
            />
        </div>
    </a>
</template>

<script>
export default {
    name: 'DownloadImage',
    props: {
        src: {
            type: String,
            required: true,
        },
        imgAlt: {
            type: String,
            required: false,
            default: null,
        },
        size: {
            type: String,
            required: true,
        },
    },
    computed: {
        fileName() {
            return this.src.replace(/.*\/storage\/\d*\//, '');
        },
    },
};
</script>

<style scoped></style>
